import styled from 'styled-components';
import Parent from '../Base/style';
const IconContainer = styled(Parent)``;

export default IconContainer;
